import { Component, ElementRef, inject, input, signal, ViewChild } from '@angular/core';
import { StarRatingComponent } from '../star-rating/star-rating.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Component({
    selector: 'satisfaction-survey',
    templateUrl: './satisfaction-survey.component.html',
    styleUrl: './satisfaction-survey.component.scss',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        StarRatingComponent,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
    ],
})
export class SatisfactionSurveyComponent
{
    enabled = input(true);

    private http = inject(HttpClient);
    private fb = inject(FormBuilder);
    protected visible = signal(false);
    protected rating = signal(0);

    @ViewChild('feedback') feedback: ElementRef;

    satisfactionSurveyForm: FormGroup;

    constructor() {
        this.satisfactionSurveyForm = this.fb.group({
            rating: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
            feedback: ['', [Validators.required]],
            state: ['']
        });

        this.satisfactionSurveyForm.valueChanges.subscribe({
            next: (changes) => {
                console.log(changes);
            }
        });
    }

    toggleSurvey() {
        this.visible.set(!this.visible());
    }

    close() {
        if (this.visible()) {
            this.visible.set(false);
        }
    }

    onSubmit() {
        // Submit the content of the satisfactionSurveyForm to the rating service.
        this.satisfactionSurveyForm.get('state').setValue(window.location.href);
        let body = this.satisfactionSurveyForm.value;

        let url_ = environment.config.remoteServiceBaseUrl + environment.config.formServiceEndpoint;
        this.http.post(url_ + '/SubmitFeedback', body)
            .subscribe({
                next: () => {
                    this.satisfactionSurveyForm.reset();
                    this.close();
                },
                error: (err) => {
                    console.log(err);
                    this.close();
                }
            });
    }
}
